@import "../../theme/global";

lar-list-item {
  background-color: $background-color-step-100 !important;
  color: $text-color !important;
}